module.exports = __webpack_public_path__ + "img/red-1-squiggly-solid.793e7b27.svg";